var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningStripIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7749_28193)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.6634 44.2993L34.8757 5.00128C33.0066 1.48033 28.6387 0.140951 25.1177 2.00986C23.8436 2.68671 22.8029 3.72724 22.1263 5.00128L1.3386 44.2993C-0.511825 47.8086 0.832176 52.1556 4.34384 54.006C5.38218 54.5543 6.54193 54.839 7.71551 54.8343H49.2862C53.2528 54.846 56.4798 51.64 56.4915 47.6709C56.4961 46.495 56.2115 45.3376 55.6632 44.2993H55.6634ZM28.501 47.8343C26.5691 47.8343 25.001 46.2662 25.001 44.3343C25.001 42.4024 26.5691 40.8343 28.501 40.8343C30.4329 40.8343 32.001 42.4024 32.001 44.3343C32.001 46.2662 30.4329 47.8343 28.501 47.8343ZM29.7377 36.1676H27.262C26.646 36.1676 26.1351 35.6893 26.0977 35.0733L25.0758 18.74C25.0337 18.0679 25.568 17.501 26.2401 17.501H30.7575C31.4294 17.501 31.9637 18.0679 31.9217 18.74L30.8996 35.0733C30.8625 35.6893 30.3537 36.1676 29.7377 36.1676H29.7377Z",
    fill: "#FF8C00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7749_28193"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningStripIcon);
export default __webpack_public_path__ + "static/media/warningStripIcon.e080d9ccba146a5c03ed19d08aa03269.svg";
export { ForwardRef as ReactComponent };